import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setImagePath } from '../../utils/helpers';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { LINK_NOT_VALID_EVENT } from '../../utils/analytics/analyticsEvents';
import { getLinkNotValidErrorContent } from '../../store/contentSlice';

const LinkNotValidError: FunctionComponent = () => {
  const { heading, message }: any = useSelector(getLinkNotValidErrorContent);
  useEffect(() => {
    capturePageLoadAnalytics(LINK_NOT_VALID_EVENT);
  }, []);

  return (
    <div className="error-pg-container">
      <div className="error-pg-box-wrapper">
        <div className="error-pg-img-wrapper">
          <img
            className="error-pg-img"
            src={setImagePath('link-not-valid')}
            alt="link not valid error"
          />
        </div>
        <div className="error-message-wrapper">
          <p className="error-pg-heading">{heading}</p>
          <p className="error-pg-message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default LinkNotValidError;
